<div class="header">
  <div>
    <a routerLink="/">
      <img src="images/logo.png" alt="logo">
    </a>
  </div>
  <div>
    @if (isAuthenticated$ | async) {
      <a routerLink="/profile" class="button-link">
        {{ (profile?.username || profile?.email) || 'Профиль' }}
      </a>
    } @else {
      <a [routerLink]="['/login']" class="button-link">
        Войти
      </a>
    }
  </div>
</div>
